import { useContractsUrl } from 'domain/people/contracts/contractsRouting';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ContractsMenu = () => {
  const { getSingleEntityUrl } = useContractsUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} exact />
    </SidebarStickyMenu>
  );
};

export default ContractsMenu;
